// First-touch acquisition capture: stash UTM params + referrer from the landing URL
// (first visit wins) so conversions can be attributed to a campaign. First-party
// localStorage only — nothing is sent until the user takes an action (e.g. signs up).
const KEY = "sc_attribution";
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "ref"];

export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch already recorded
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 200); });
    if (Object.keys(found).length === 0) return; // no campaign/referral params → don't overwrite organic
    found.referrer = (document.referrer || "").slice(0, 200);
    found.landing_path = window.location.pathname.slice(0, 200);
    localStorage.setItem(KEY, JSON.stringify(found));
  } catch { /* ignore */ }
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}
